import React, { useState, useEffect } from 'react';
import axios from 'axios';
import useAuth from '../../../config/useAuth';
import { useParams } from 'react-router-dom';
import { API_PATH } from '../../../Constant/constants';



const MedicineStock = () => {
  const [transactions, setTransactions] = useState([]);
  const [error, setError] = useState('');
  const { medicineId } = useParams();
  const { token } = useAuth();

  useEffect(() => {
    fetchTransactions();
  }, [medicineId]);

  const fetchTransactions = async () => {
    try {
      const response = await axios.get(
        `${API_PATH}/inventory/transaction/${medicineId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setTransactions(response.data || []);
      setError('');
    } catch (err) {
      console.error('Error fetching transactions:', err);
      setError('Failed to fetch transaction data. Check medicine ID or token.');
      setTransactions([]);
    }
  };

  return (
    <div className="container my-4">
      <h4 className="mb-4">Medicine Transaction History</h4>

      {error && (
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      )}

      {transactions.length > 0 ? (
        <div className="card shadow-sm border-0">
          <div className="card-header bg-secondary text-white">
            <h5 className="mb-0">Transactions for Medicine ID: {medicineId}</h5>
          </div>
          <div className="card-body p-0">
            <div className="table-responsive">
              <table className="table table-striped mb-0">
                <thead className="table-light">
                  <tr>
                    <th>#</th>
                    <th>Medicine Name</th>
                    <th>Transaction Type</th>
                    <th>Quantity</th>
                    <th>Transaction Date</th>
                    <th>User ID</th>
                  </tr>
                </thead>
                <tbody>
                  {transactions.map((txn, index) => (
                    <tr key={txn.id}>
                      <td>{index + 1}</td>
                      <td>{txn.medicineName}</td>
                      <td>{txn.transactionType}</td>
                      <td>{txn.quantity}</td>
                      <td>{new Date(txn.transactionDate).toLocaleString()}</td>
                      <td>{txn.userId}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ) : (
        !error && <p>No transactions found for this medicine.</p>
      )}
    </div>
  );
};

export default MedicineStock;
